const envApiUrl: unknown = import.meta.env.VITE_API_URL;

export const API_URL = typeof envApiUrl === 'string' ? envApiUrl : '';

export function apiUrl(path: string): string {
  return `${API_URL}${path}`;
}
